export const CampaignCheckStatuses = {
    Queued: "queued", // newly created records
    Sent: "sent", // checked that mailWizz marked campaign as 'Sent'
    Checked: "checked", // gmass results were processed
    Errored: "errored" // something went wrong
}